import { forwardRef } from 'react';

import { DataTestId } from '../../../core/types/data-props.js';
import { StylingProps } from '../../../core/types/styling-props.js';
import { WithChildren } from '../../../core/types/with-children.js';

//#region Typings
/**
 * @public
 */
export interface EmptyStateTitleProps
  extends WithChildren, StylingProps, DataTestId {
  /**
   * The polymorphed HTML tag that determines the semantic level of the title.
   * Default value depends on the empty state size prop.
   * @defaultValue h1, h3 or h6
   */
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
}
//#endregion Typings

/**
 * The title slot of the EmptyState component.
 * @public
 */
export const Title =
  /* @__PURE__ */
  forwardRef<HTMLDivElement, EmptyStateTitleProps>((props, forwardedRef) => {
    const {
      children,
      className: consumerClassName,
      style: consumerStyle,
      'data-testid': dataTestId,
    } = props;

    return (
      <div
        ref={forwardedRef}
        className={consumerClassName}
        style={consumerStyle}
        data-testid={dataTestId}
      >
        {children}
      </div>
    );
  });

(Title as typeof Title & { displayName: string }).displayName =
  'EmptyState.Title';
